<template>
  <div class="success full-size flex-vertical">
    <img class="success-logo" src="../../public/icons/logo.svg" />
    <div class="success-main flex-vertical">
      <div class="success-main-icon">
        <img src="../../public/icons/success-96.svg"/>
      </div>
      <div class="success-main-title font-bold-32px">
        Документы<br />
        отправлены на обработку
      </div>
      <div class="success-main-text font-regular-16px">
        В случае возникновения проблем с вами свяжется<br />
        представитель компании СИБУР
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessPage",
};
</script>

<style lang="scss" scoped>
@import "../../src/styles/colors.scss";

.success {
  background-color: $background-color;
  align-items: center;
}

.success-logo {
  position: relative;
  top: 16%;
}

.success-main {
  position: relative;
  top: 30%;
  align-items: center;
}

.success-main-icon {
  margin-bottom: 32px;
}

.success-main-title {
  text-align: center;
}

.success-main-text {
  text-align: center;
}

@media screen and (max-width: 500px) {
  .success-logo {
    display: none;
  }

  .success-main {
    top: 20%;
  }

  .success-main-title {
    font-size: 20px;
    margin-bottom: 16px;
  }

  .success-main-text {
    font-size: 13px;
  }
}
</style>